import Tooltip from 'rc-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { Text } from '@querodelivery/uni-react';
import styles from './distribution-rules-box.module.scss';
import { celularLabel } from '@/Utils/FnUtils';
import { UNAVAILABLE_LABEL } from '@/_constants/strings';
import { colors } from '@/Themes/Colors';
import {
  OrderProxyPhone,
  type DeliveryProxy,
} from '@/_features/deliveries/componentes/order-proxy-phone/order-proxy-phone';

interface DistributionRulesBoxProps {
  deliveryRadius?: string;
  maxDistanceBetweenDeliveries?: string;
  maxDeliveriesPerDeliveryman?: number;
  dedicatedDeliveryman?: boolean;
  dedicatedOrder?: boolean;
  customerName?: string;
  proxy?: DeliveryProxy;
  customerPhone?: string;
  deliveryAddress?: string;
  reference?: string;
  observations?: string;
}

export const DistributionRulesBox = ({
  deliveryRadius,
  dedicatedDeliveryman,
  dedicatedOrder,
  maxDeliveriesPerDeliveryman,
  maxDistanceBetweenDeliveries,
  customerName,
  proxy,
  customerPhone,
  deliveryAddress,
  reference,
  observations,
}: DistributionRulesBoxProps) => {
  const formattedDeliveryRadius = deliveryRadius
    ? `${deliveryRadius} km`
    : '- - -';

  const formattedMaxDistanceBetweenDeliveries = maxDistanceBetweenDeliveries
    ? `${maxDistanceBetweenDeliveries} km`
    : '- - -';

  const formattedMaxDeliveriesPerDeliveryman =
    maxDeliveriesPerDeliveryman || '- - -';

  const formattedDedicatedDeliveryman = dedicatedDeliveryman ? 'Sim' : 'Não';
  const formattedDedicatedOrder = dedicatedOrder ? 'Sim' : 'Não';
  const formattedCustomerName = customerName || UNAVAILABLE_LABEL;

  const formattedCustomerPhone = customerPhone
    ? celularLabel(customerPhone)
    : UNAVAILABLE_LABEL;

  return (
    <div className={styles.container}>
      <div className={styles.deliveryInformationContainer}>
        <div className={styles.deliveryInformation}>
          <div>
            <span>Nome do cliente</span>
            <span
              style={{
                color:
                  formattedCustomerName === UNAVAILABLE_LABEL
                    ? colors.gray10
                    : '',
              }}
            >
              {formattedCustomerName}
            </span>
          </div>
          {proxy ? (
            <div className={styles.proxyPhoneRow}>
              <OrderProxyPhone proxy={proxy} />
            </div>
          ) : (
            <div className={styles.customerPhoneRow}>
              <span>Telefone do cliente</span>
              {customerPhone ? (
                <span>{formattedCustomerPhone}</span>
              ) : (
                <span style={{ color: colors.gray10 }}>
                  {UNAVAILABLE_LABEL}
                </span>
              )}
            </div>
          )}
          <div>
            <span>Endereço da entrega</span>
            <span
              style={{
                color:
                  deliveryAddress === UNAVAILABLE_LABEL ? colors.gray10 : '',
              }}
            >
              {deliveryAddress}
            </span>
          </div>
          {reference && (
            <div>
              <span>Referência</span>
              <span>{reference}</span>
            </div>
          )}
          {observations && (
            <div>
              <span>Observações</span>
              <span>{observations}</span>
            </div>
          )}
        </div>
      </div>

      <Text
        fontSize="md"
        lineHeight="lg"
        fontWeight="semibold"
        tone="supporting"
      >
        Regras de distribuição
      </Text>

      <div className={styles.deliveryInformationContainer}>
        <div className={styles.deliveryInformation}>
          <div>
            <span>Raio de disparo</span>
            <span>{formattedDeliveryRadius}</span>
          </div>
          <div>
            <span>
              Distância limite entre entregas{' '}
              <Tooltip overlay="Distância máxima em km entre duas entregas simultâneas.">
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  style={{
                    fontSize: 14,
                  }}
                />
              </Tooltip>
            </span>
            <span>{formattedMaxDistanceBetweenDeliveries}</span>
          </div>
          <div>
            <span>Quantidade de entregas por entregador</span>
            <span>{formattedMaxDeliveriesPerDeliveryman}</span>
          </div>
          <div>
            <span>Entregador dedicado</span>
            <span>{formattedDedicatedDeliveryman}</span>
          </div>
          <div>
            <span>Pedido dedicado</span>
            <span>{formattedDedicatedOrder}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
